import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { getExpiredFutureStartDateLineItemIds } from '../../state/BuyerOverrides/selectors';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const MaybeExpiredFutureLineItemsAlert = () => {
  const history = useHistory();
  const expiredFutureStartDateLineItemIds = useSelector(getExpiredFutureStartDateLineItemIds);
  if (!expiredFutureStartDateLineItemIds.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "600",
    as: "div",
    children: /*#__PURE__*/_jsx(Alert, {
      type: "danger",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "payments.futureChargesTotals.expiredErrorAlertMessage_jsx",
        options: {
          onClick: () => history.go(0)
        },
        elements: {
          Link
        }
      })
    })
  });
};
export default MaybeExpiredFutureLineItemsAlert;